import apiService from './apiService';
import portService from './portService';
import rakePointService from './rakePointService';

class MasterDataService {
  async getDrivers(skip = 0, limit = 1000, availableOnly = false, includeInactive = false, search = '') {
    try {
      let endpoint = `/api/v1/entities/drivers/?skip=${skip}&limit=${limit}&available_only=${availableOnly}&include_inactive=${includeInactive}`;

      if (search) {
        endpoint += `&search=${encodeURIComponent(search)}`;
      }

      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch drivers:', error);
      throw error;
    }
  }

  async getDriverById(id) {
    try {
      const endpoint = `/api/v1/entities/drivers/${id}`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch driver by id:', error);
      throw error;
    }
  }

  async getTransporters(skip = 0, limit = 1000, includeInactive = false, search = '') {
    try {
      let endpoint = `/api/v1/entities/transporters/?skip=${skip}&limit=${limit}&include_inactive=${includeInactive}`;
      if (search) {
        endpoint += `&search=${encodeURIComponent(search)}`;
      }
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch transporters:', error);
      throw error;
    }
  }

  async getDistributors(skip = 0, limit = 1000, includeInactive = false, search = '') {
    try {
      let endpoint = `/api/v1/entities/distributors/?skip=${skip}&limit=${limit}&include_inactive=${includeInactive}`;
      if (search) {
        endpoint += `&company_name=${encodeURIComponent(search)}`;
      }
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch distributors:', error);
      throw error;
    }
  }

  async getRetailers(skip = 0, limit = 1000, includeInactive = false, districtId = null, search = '') {
    try {
      let endpoint = `/api/v1/entities/retailers/?skip=${skip}&limit=${limit}&include_inactive=${includeInactive}`;
      if (districtId) {
        endpoint += `&district_id=${districtId}`;
      }
      if (search) {
        endpoint += `&search=${encodeURIComponent(search)}`;
      }
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch retailers:', error);
      throw error;
    }
  }

  async getVehicles(skip = 0, limit = 1000, activeOnly = false, includeInactive = false, search = '') {
    try {
      let endpoint = `/api/v1/entities/vehicles/?skip=${skip}&limit=${limit}&active_only=${activeOnly}&include_inactive=${includeInactive}`;

      if (search) {
        endpoint += `&vehicle_number=${encodeURIComponent(search)}`;
      }

      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch vehicles:', error);
      throw error;
    }
  }

  async getPorts(skip = 0, limit = 500) {
    try {
      const response = await portService.getPorts(skip, limit);
      return response;
    } catch (error) {
      console.error('Failed to fetch ports:', error);
      throw error;
    }
  }

  async getRakePoints(pointType = '') {
    try {
      const response = await rakePointService.getRakePointsDropdown(pointType);
      return response;
    } catch (error) {
      console.error('Failed to fetch rake points dropdown:', error);
      throw error;
    }
  }


  async getStates(activeOnly = true) {
    try {
      const endpoint = `/api/v1/entities/states/?active_only=${activeOnly}`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch states:', error);
      throw error;
    }
  }

  async getDistrictsByState(stateId, activeOnly = true) {
    try {
      const endpoint = `/api/v1/entities/districts/state/${stateId}?active_only=${activeOnly}`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch districts:', error);
      throw error;
    }
  }

  async getDistributorsByDistrict(districtId, search = '', skip = 0, limit = 50, includeInactive = false) {
    try {
      let endpoint = `/api/v1/entities/distributors/district/${districtId}?skip=${skip}&limit=${limit}&include_inactive=${includeInactive}`;

      if (search) {
        endpoint += `&search=${encodeURIComponent(search)}`;
      }

      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch distributors by district:', error);
      throw error;
    }
  }
}

export default new MasterDataService();